import Navbar from "../components/Navbar";
import "./RegistroEnviado.css";
import "./TextosLegales.css";

const PoliticaPrivacidad = () => {
  return (
    <div className="p-6 space-y-6 text-justify text-sm leading-relaxed max-w-3xl mx-auto">
      <p>
        <strong>Aplicación "PASAPORTE HACIA EL EMPLEO"</strong>
      </p>
      <p>
        <strong>Última actualización:</strong> 29/05/2025
      </p>

      <h2 className="text-base font-bold mt-6">1. ¿Quién es el Responsable del Tratamiento de tus datos?</h2>
      <p>
        <strong>Ayuntamiento de Isla Cristina</strong>
        <br />
        CIF: P-2104200-G
        <br />
        Dirección: Avenida Gran Vía, 43, 21410 Isla Cristina (Huelva)
        <br />
        Correo electrónico: ayuntamiento@islacristina.org
        <br />
        Teléfono: 959 331 912
      </p>

      <h2 className="text-base font-bold mt-6">2. ¿Con qué finalidad tratamos tus datos personales?</h2>
      <p>Los datos personales facilitados a través de esta aplicación serán tratados con la finalidad de:</p>
      <ul className="list-disc ml-6">
        <li>Facilitar el uso de la plataforma digital "PASAPORTE HACIA EL EMPLEO".</li>
        <li>Gestionar la participación en talleres, acciones de capacitación y otras actividades del proyecto.</li>
        <li>
          Proporcionar acceso personalizado a funcionalidades como orientación laboral, registro de formación, citas con agentes sociales, y
          herramientas de seguimiento de empleabilidad.
        </li>
        <li>Realizar comunicaciones relacionadas con el proyecto.</li>
        <li>Elaborar informes y estadísticas, de forma anonimizada, para el seguimiento de resultados.</li>
      </ul>

      <h2 className="text-base font-bold mt-6">3. ¿Cuál es la base legal para el tratamiento de tus datos?</h2>
      <p>El tratamiento se basa en:</p>
      <ul className="list-disc ml-6">
        <li>
          <strong>El cumplimiento de una misión de interés público</strong>, conforme al artículo 6.1.e) del RGPD.
        </li>
        <li>
          <strong>El consentimiento del interesado</strong>, cuando sea necesario (por ejemplo, en comunicaciones o uso de determinadas
          funcionalidades).
        </li>
        <li>
          El proyecto está cofinanciado por la Unión Europea mediante el <strong>Mecanismo para la Recuperación y Resiliencia (MRR)</strong>{" "}
          dentro del Plan de Recuperación, Transformación y Resiliencia (PRTR), en el marco del Componente 22 "Economía de los cuidados e
          inclusión social".
        </li>
      </ul>

      <h2 className="text-base font-bold mt-6">4. ¿Qué tipo de datos tratamos?</h2>
      <p>Se tratarán únicamente los datos necesarios para el correcto funcionamiento de la app, tales como:</p>
      <ul className="list-disc ml-6">
        <li>Datos identificativos: nombre, apellidos, DNI/NIE.</li>
        <li>Datos de contacto: correo electrónico, teléfono.</li>
        <li>Datos de empleabilidad: formación, experiencia laboral, citas con profesionales, actividades realizadas, etc.</li>
        <li>Información de uso de la app y estadísticas.</li>
      </ul>
      <p>
        No se recogen datos especialmente sensibles salvo que sean necesarios para garantizar el acompañamiento personalizado y siempre con
        consentimiento explícito.
      </p>

      <h2 className="text-base font-bold mt-6">5. ¿Por cuánto tiempo conservamos tus datos?</h2>
      <p>
        Tus datos se conservarán durante la duración del proyecto y, posteriormente, por los plazos exigidos por la normativa aplicable en
        materia de archivo, control y justificación de fondos públicos. Posteriormente se suprimirán o anonimizarán de forma segura.
      </p>

      <h2 className="text-base font-bold mt-6">6. ¿A quién comunicamos tus datos?</h2>
      <p>Tus datos podrán ser comunicados a:</p>
      <ul className="list-disc ml-6">
        <li>
          Las entidades participantes en la Red de Empleo Local de Isla Cristina, únicamente en el marco del proyecto y según tus usos de la
          aplicación.
        </li>
        <li>
          Organismos financiadores (Junta de Andalucía, Ministerio de Derechos Sociales, Unión Europea) en el contexto de auditorías,
          justificaciones o evaluación del proyecto.
        </li>
        <li>Proveedores tecnológicos que prestan servicios a la plataforma, con contrato de tratamiento de datos conforme al RGPD.</li>
      </ul>
      <p>No se prevén transferencias internacionales de datos.</p>

      <h2 className="text-base font-bold mt-6">7. ¿Cuáles son tus derechos?</h2>
      <p>Puedes ejercer los siguientes derechos:</p>
      <ul className="list-disc ml-6">
        <li>Acceso a tus datos.</li>
        <li>Rectificación de los datos inexactos.</li>
        <li>Supresión (derecho al olvido), cuando sea aplicable.</li>
        <li>Oposición al tratamiento, en determinados casos.</li>
        <li>Limitación del tratamiento.</li>
        <li>Portabilidad, si es técnicamente posible.</li>
      </ul>
      <p>
        Puedes ejercerlos a través de correo electrónico o presencialmente en el Ayuntamiento. En caso de desacuerdo, puedes reclamar ante
        la <strong>Agencia Española de Protección de Datos</strong> (
        <a href="https://www.aepd.es" className="text-blue-600 underline" target="_blank" rel="noopener noreferrer">
          www.aepd.es
        </a>
        ).
      </p>

      <h2 className="text-base font-bold mt-6">8. Seguridad de los datos</h2>
      <p>
        La aplicación aplica medidas de seguridad técnicas y organizativas conforme al <strong>Esquema Nacional de Seguridad</strong> y al{" "}
        <strong>Reglamento Europeo de Protección de Datos</strong>, para garantizar la confidencialidad, integridad y disponibilidad de los
        datos.
      </p>
    </div>
  );
};

export default PoliticaPrivacidad;
